export const accountRoutes = [
  { path: '/checkout', name: 'Checkout', component: () => import('@/pages/account/CheckoutPage.vue') },
  { path: '/profile', name: 'UserProfile', component: () => import('@/pages/account/AccountProfilePage.vue') },
  { path: '/payment', redirect: '/p/journal' },
  { path: '/account/credits', name: 'AcademicCredits', component: () => import('@/pages/account/AcademicCreditsPage.vue') },
  { path: '/account-status', redirect: '/account/credits' },
  { path: '/admin/sku', name: 'CatalogAdmin', component: () => import('@/pages/admin/CatalogAdminPage.vue') },
];
